import { Link } from 'react-router-dom';
import { cardFrame, riseDelay } from '../marketplace/frames';
import { ResultThumb, ResultPrice } from './SearchResultRow';

/** Card used on the /search results page. */
export const SearchResultCard = ({ item, index, isAr, isDarkMode, sectionLabel, onOpen }) => (
  <Link
    to={item.url}
    onClick={onOpen}
    style={riseDelay(index)}
    data-testid={`search-result-${item.section}-${index}`}
    className={`group animate-fadeIn flex items-center gap-4 p-4 rounded-2xl transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 ${cardFrame(isDarkMode)}`}
  >
    <ResultThumb item={item} isDarkMode={isDarkMode} size="h-16 w-16" />
    <div className="min-w-0 flex-1">
      <p className={`text-[11px] font-bold mb-1 ${isDarkMode ? 'text-[#38BDF8]' : 'text-[#0284C7]'}`}>{sectionLabel}</p>
      <p className={`truncate font-semibold ${isDarkMode ? 'text-white' : 'text-slate-900'}`} dir="auto">{isAr ? item.title_ar : item.title_en}</p>
      <p className={`truncate text-xs mt-0.5 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`} dir="auto">{isAr ? item.subtitle_ar : item.subtitle_en}</p>
      <div className="mt-2"><ResultPrice item={item} /></div>
    </div>
  </Link>
);
